import { Grid, styled } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import { PropsWithChildren } from 'react';

import HideIcon from '../../../assets/svg/HideIcon';
import ShowIcon from '../../../assets/svg/ShowIcon';
import Text, { TextProps } from '../../../react-components/Text';

interface InfoBoxProps {
  title: string;
  showText?: string;
  hideText?: string;
  hide?: boolean;
  onHide?: (status: boolean) => void;
}
const EyeSelectorContainer = styled(Grid)`
  width: 30px !important;
  height: 32px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  padding-left: 8px;
  margin-right: 8px;
  border-left: 1px solid #cacaca;
`;

export const InfoBox = ({ title, showText, hideText, hide, onHide, children }: PropsWithChildren<InfoBoxProps>) => {
  return (
    <div
      style={{
        borderRadius: `4px`,
        border: `1px solid #CACACA`,
      }}
    >
      <Grid container direction="row" wrap="nowrap" alignItems="center" style={{ borderBottom: `1px solid #CACACA` }}>
        <Text
          style={{
            padding: `8px`,
            display: `flex`,
          }}
        >
          {title}
        </Text>

        {onHide && (
          <Grid
            container
            direction="row"
            alignItems="center"
            onClick={() => {
              onHide && onHide(!hide);
            }}
            style={{
              cursor: `pointer`,
              width: `unset`,
              height: `32px`,
            }}
          >
            <EyeSelectorContainer container>
              {hide ? (
                <HideIcon height="18px" width="22px" style={{ color: RoutalPalette.text, marginTop: `3px` }} />
              ) : (
                <ShowIcon height="20px" width="22px" style={{ color: RoutalPalette.text, marginBottom: `5px` }} />
              )}
            </EyeSelectorContainer>
            <Text
              style={{
                display: `flex`,
                marginTop: `1px`,
                cursor: `inherit`,
              }}
            >
              {!hide ? hideText : showText}
            </Text>
          </Grid>
        )}
      </Grid>

      {children}
    </div>
  );
};

interface InfoBoxItemProps {
  icon?: React.ReactElement;
  label: string;
  childrenItemProps?: Record<string, any>;
}

export const InfoBoxItem = ({ icon, label, childrenItemProps = {}, children }: PropsWithChildren<InfoBoxItemProps>) => {
  return (
    <Grid container direction="row" style={{ margin: `16px 0` }} alignItems="center">
      {icon ? (
        <>
          {icon}
          <HSpacer small />
        </>
      ) : null}
      <Grid item>
        <Text variant="label">{label}</Text>
      </Grid>
      <HSpacer small />
      <Grid item {...childrenItemProps}>
        {children}
      </Grid>
    </Grid>
  );
};

export const InfoBoxText = (props: React.PropsWithChildren<TextProps> & React.DOMAttributes<TextProps>) => {
  const { children, ...textProps } = props;
  return (
    <Text {...textProps} isBold>
      {children}
    </Text>
  );
};
